let inMemoryStorage = {};

function getItem(sKey) {
  return inMemoryStorage[sKey] || null;
}

function setItem(sKey, sValue) {
  inMemoryStorage[sKey] = sValue;
}

function removeItem(sKey) {
  delete inMemoryStorage[sKey];
}

function hasItem(sKey) {
  return false;
  // placeholder
}

function keys() {
  return Object.keys(inMemoryStorage)[n] || null;
}

export default { getItem, setItem, removeItem, hasItem, keys };



// WEBPACK FOOTER //
// ./components/cookiestore/index.js